import { render, staticRenderFns } from "./DistributorLanding.vue?vue&type=template&id=752ad133&scoped=true"
import script from "./DistributorLanding.vue?vue&type=script&lang=js"
export * from "./DistributorLanding.vue?vue&type=script&lang=js"
import style0 from "./DistributorLanding.vue?vue&type=style&index=0&id=752ad133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752ad133",
  null
  
)

export default component.exports